import { MenuItem } from 'types/navigation.type';
import { UserGroupName } from 'types/user.type';

export const menuItems: MenuItem = {
  name: 'NAVIGATION',
  items: [
    {
      name: 'Laundry',
      url: '/laundry',
      userGroup: UserGroupName.Laundry,
      items: [
        {
          name: 'Import Users By Email',
          url: '/laundry/importbyemail',
        },
        {
          name: 'Import from company',
          url: '/laundry/importfromcompany',
        },
        {
          name: 'List Import Status',
          url: '/laundry/listimportstatus',
        },
        {
          name: 'Reports',
          url: '/laundry/reports',
        },
      ],
    },
    {
      name: 'Export',
      url: '/export',
      userGroup: UserGroupName.Export,
      items: [
        {
          name: 'Download products',
          url: '/export/products',
        },
        {
          name: 'BMECAT',
          enabled: false,
          hovertext: 'Moved to Entities',
          url: '#',
        },
      ],
    },
    {
      name: 'Import',
      url: '/import',
      userGroup: UserGroupName.Import,
      items: [
        {
          name: 'Import Users By Excel',
          url: '/import/importbyexcel',
        },
        {
          name: 'User Import Status',
          url: '/import/userimportstatus',
        },
        {
          name: 'Outlet Pricelist',
          url: '/import/outletpricelist',
          extendedPermission: "outlet-import"
        },
        {
          name: 'Phrase Translation Status',
          url: '/import/translationstatus',
          extendedPermission: "translation-status"
        },
      ],
    },
    {
      name: 'Admin',
      url: '/admin',
      userGroup: UserGroupName.Admin,
      requiresAdminGroup: true,
      items: [
        {
          name: 'Users',
          url: '/admin/users',
        },
        {
          name: 'Permissions',
          url: '/admin/permissions',
          extendedPermission: 'permissions'
        },
        {
          name: 'Roles',
          url: '/admin/roles',
        },
        {
          name: 'Feature Flags',
          url: '/admin/featureflags',
        },
      ],
    },
    {
      name: 'Giveaway',
      url: '/giveaway',
      userGroup: UserGroupName.Giveaway,
      items: [
        {
          name: 'Items',
          url: '/giveaway/items',
        },
        {
          name: 'Code Groups',
          url: '/giveaway/code-groups',
        },
        {
          name: 'Codes',
          url: '/giveaway/codes',
        },
        {
          name: 'Orders',
          url: '/giveaway/orders',
        },
        {
          name: 'D365 Settings',
          url: '/giveaway/d365-settings',
        },
        {
          name: 'Shop Settings',
          url: '/giveaway/shop-settings/login',
        },
      ],
    },
    {
      name: 'Notifications',
      url: '/notifications',
      userGroup: UserGroupName.Notifications,
    },
    {
      name: 'Hangtight',
      url: '/hangtight',
      userGroup: UserGroupName.Wellhung,
      items: [
        {
          name: 'Events',
          url: '/hangtight/events',
        },
        {
          name: 'Registrations',
          url: '/hangtight/registrations',
        },
        {
          name: 'Export',
          url: '/hangtight/export',
        },
      ],
    },
    {
      name: 'EU Conformity',
      url: '/euconformity',
      userGroup: UserGroupName.EuConformity,
    },
    {
      name: 'Delivery Methods',
      url: '/delivery-methods',
      userGroup: UserGroupName.DeliveryMethods,
      items: [
        {
          name: 'Delivery methods',
          url: '/delivery-methods/list',
          extendedPermission: 'delivery-methods',
        },
        {
          name: 'Delivery method groups',
          url: '/delivery-methods/groups',
          extendedPermission: 'delivery-method-groups',
        },
        {
          name: 'Company associations',
          url: '/delivery-methods/company-associations',
          extendedPermission: 'delivery-method-groups',
        },
      ],
    },
    {
      name: 'Size Groups',
      url: '/size-groups',
      userGroup: UserGroupName.Products,
    },
    {
      name: 'Norce Management',
      url: '/norce',
      userGroup: UserGroupName.NorceManagement,
    },
    {
      name: 'Customers',
      url: '/customers',
      userGroup: UserGroupName.Customers,
      items: [
        {
          name: 'Reset password',
          url: '/customers/reset-password',
        },
      ],
    },
  ],
};
